import { render, staticRenderFns } from "./autoresponderPreview.vue?vue&type=template&id=68aca48e&scoped=true&"
import script from "./autoresponderPreview.vue?vue&type=script&lang=js&"
export * from "./autoresponderPreview.vue?vue&type=script&lang=js&"
import style0 from "./autoresponderPreview.vue?vue&type=style&index=0&id=68aca48e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aca48e",
  null
  
)

export default component.exports